export var PRICE_PERIOD = /*#__PURE__*/function (PRICE_PERIOD) {
  PRICE_PERIOD["Month"] = "month";
  PRICE_PERIOD["Day"] = "day";
  PRICE_PERIOD["Hour"] = "hour";
  return PRICE_PERIOD;
}({});